import React, { Fragment } from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {
  FormField,
  FormFields,
  LoggerFactory,
  evaluateWithContext,
  checkGroupVisibility
} from "../../index";

const log = LoggerFactory.create("TabsForm");

export interface TabPanelProps {
  children?: any;
  index: any;
  value: any;
}

export interface TabsFormProps {
  groups: { [name: string]: FormFields };
  mapper: (fields: FormField[]) => any[];
  data: any;
}

export interface TabsFormState {
  tabIndex: number;
}

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
};

export class TabsFormComponent extends React.Component<
  TabsFormProps,
  TabsFormState
> {
  public constructor(props: TabsFormProps) {
    super(props);
    this.state = { tabIndex: 0 };
  }

  public render() {
    const { groups, mapper } = this.props;

    log.debug("groups", groups);

    return (
      <>
        <Tabs
          value={this.state.tabIndex}
          onChange={this.onChange}
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          {Object.entries(groups).map(([groupName, schema]) => {
            log.debug("groupEntry", groupName, schema);
            const evaluatedGroupName =
              evaluateWithContext({}, schema.groups[groupName]) || groupName;
            if (checkGroupVisibility(schema, this.props.data)) {
              return (
                <Tab
                  label={evaluatedGroupName}
                  id={groupName}
                  key={groupName}
                />
              );
            } else {
              return <></>;
            }
          })}
        </Tabs>
        {Object.entries(groups).map(([groupName, schema], index) => {
          if (checkGroupVisibility(schema, this.props.data)) {
            return (
              <TabPanel
                value={this.state.tabIndex}
                index={index}
                key={groupName}
              >
                {mapper(this.mapFields(schema))}
              </TabPanel>
            );
          } else {
            return <Fragment key={groupName} />;
          }
        })}
      </>
    );
  }

  private mapFields(schema: FormFields) {
    return schema.mapFields(f => f, { data: this.props.data });
  }

  private onChange = (event: React.ChangeEvent<Object>, newValue: number) => {
    this.setState({ tabIndex: newValue });
  };
}
